import React, { useState } from "react";
import cx from "classnames";
import "./ExpandableSneakPeakCard.scss";
import { AnimatePresence, motion } from "framer-motion";
export const CardBottom = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
const AnimateSneakPeakHeight = ({ children, isOpen, duration = 0.3, fadeVisibleContent = true, contentHeight, }) => {
    const variants = {
        visible: {
            height: "auto",
            overflow: "none",
            webkitMaskImage: "none",
            maskImage: "none",
        },
        hidden: {
            height: contentHeight,
            overflow: "hidden",
            maskImage: "linear-gradient(to top, transparent -1%, black 50%)",
            webkitMaskImage: "linear-gradient(to top, transparent -1%, black 50%)",
        },
        hiddenNoFade: {
            height: contentHeight,
            overflow: "hidden",
        },
    };
    return (React.createElement(AnimatePresence, null,
        React.createElement(motion.div, { initial: fadeVisibleContent ? "hidden" : "hiddenNoFade", animate: isOpen ? "visible" : fadeVisibleContent ? "hidden" : "hiddenNoFade", variants: variants, transition: { duration } }, children)));
};
export const ExpandableSneakPeakCard = ({ children, className, buttonOpenText, buttonCloseText, style, startOpen = false, fadeVisibleContent = true, contentHeight = 150, }) => {
    const [isOpen, setIsOpen] = useState(startOpen);
    return (React.createElement("div", { className: "expandable-sneak-peak-card" },
        React.createElement("div", { className: cx(className, "card", "lysa-ui-card-expandable"), style: style },
            React.createElement("div", { className: "content-wrapper" },
                React.createElement("div", { id: "expandable-card-hidden-content", "aria-hidden": !isOpen },
                    React.createElement(AnimateSneakPeakHeight, { isOpen: isOpen, fadeVisibleContent: fadeVisibleContent, contentHeight: contentHeight },
                        React.createElement("div", { className: cx("inner-content-wrapper", { open: isOpen }) }, children)))),
            React.createElement("div", { className: "card-bottom" },
                React.createElement(CardBottom, null,
                    React.createElement("button", { type: "button", "aria-controls": "expandable-card-hidden-content", "aria-expanded": isOpen, onClick: () => setIsOpen(!isOpen) }, isOpen ? buttonCloseText : buttonOpenText))))));
};
